module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_8003.e68bc81c.png";